import { css } from '@emotion/react';

import { colors } from '../../global';

export const ButtonSecondary = css`
    color: ${colors.turquoise};

    &.pengestyrke {
        color: ${colors.white};
        background-color: ${colors.elephant};

        &:hover {
            text-decoration: none;
        }
    }
`;
